import axios from "axios"

// const
export const EQUIPMENT_TYPE_EDIT_INITIAL_DATA = "equipmentTypeEdit/EQUIPMENT_TYPE_EDIT_INITIAL_DATA";
export const EQUIPMENT_TYPE_EDIT_UPDATE_DATA = "equipmentTypeEdit/EQUIPMENT_TYPE_EDIT_UPDATE_DATA";
export const EQUIPMENT_TYPE_EDIT_TOGGLE_MODAL = "equipmentTypeEdit/EQUIPMENT_TYPE_EDIT_TOGGLE_MODAL";
export const EQUIPMENT_TYPE_EDIT_TOGGLE_LOADING = "equipmentTypeEdit/EQUIPMENT_TYPE_EDIT_TOGGLE_LOADING";
export const EQUIPMENT_TYPE_EDIT_TOGGLE_SELECT = "equipmentTypeEdit/EQUIPMENT_TYPE_EDIT_TOGGLE_SELECT";

//modal const
export const EQUIPMENT_TYPE_EDIT_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_success_title";
export const EQUIPMENT_TYPE_EDIT_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_fail_title";
export const EQUIPMENT_TYPE_EDIT_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editSuccess_content";
export const EQUIPMENT_TYPE_EDIT_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_editFail_content";
export const EQUIPMENT_TYPE_EDIT_MODAL_OK_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_OK_label";
export const EQUIPMENT_TYPE_EDIT_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeEdit_modal_cancel_label";

export const equipmentTypeEdit = (state = {
  loading: false,

  isAuthenticated: false,
  releaseUserId: "",
  releaseUserName: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipmentTypeId: "",
  code: "",
  name: "",
  description: "",
  ifDynamic: true,
  ifEnabled: true,
}, action) => {
  switch (action.type) {
    case EQUIPMENT_TYPE_EDIT_INITIAL_DATA:
      return {
        ...state,
        loading: false,
        modalVisible: false,
        equipmentTypeId: action.data.id,
        code: action.data.code,
        name: action.data.name,
        description: action.data.description,
        ifDynamic: action.data.ifDynamic,
        ifEnabled: action.data.ifEnabled,
      };
    case EQUIPMENT_TYPE_EDIT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_TYPE_EDIT_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_TYPE_EDIT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};


/**
 * update data based on user input
 */
export const updateEquipmentTypeEditData = (data) => {
  return {
    type: EQUIPMENT_TYPE_EDIT_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init equipment type
 */
export const initEquipmentType = (data) => (dispatch) => {
  let equipmentTypeId = data.equipmentTypeId;
  if (equipmentTypeId !== null && equipmentTypeId !== undefined && equipmentTypeId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentTypeById/${equipmentTypeId}`, {contentType: "application/json"}).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.data) {
          dispatch(storeEquipmentType(response.data));
        } else {
          this.props.history.push("/exception/415");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

export const storeEquipmentType = (equipmentType) => {
  return {
    type: EQUIPMENT_TYPE_EDIT_INITIAL_DATA,
    data: equipmentType
  }
};

/**
 * submit data
 * @deprecated since 20220909
 */
export const submitEquipmentType = (data) => {
  return (dispatch) => {
    dispatch(toggleLoading(true));
    console.log(data);
    axios({
      method: "PUT",
      url: "/api-equipment/submitEquipmentType",
      contentType: "application/json",
      withCredentials: true,
      data: {
        "id": data.equipmentTypeId,
        "name": data.name,
        "code": data.code,
        "description": data.description,
        "ifDynamic": data.ifDynamic,
        "updateById": data.releaseUserId,
        "updateByName": data.releaseUserName,
        "ifEnabled": true,
      },
    }).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.status === 200) {
          console.info("success submit equipment type");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_TYPE_EDIT_MODAL_SUCCESS_TITLE,
            modalContent: EQUIPMENT_TYPE_EDIT_MODAL_SUBMIT_SUCCESS_CONTENT,
            modalOk: EQUIPMENT_TYPE_EDIT_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_TYPE_EDIT_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
              this.props.history.goBack();
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
              this.props.history.goBack();
            }
          }));
        } else {
          console.error("fail to submit equipment type");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_TYPE_EDIT_MODAL_FAIL_TITLE,
            modalContent: EQUIPMENT_TYPE_EDIT_MODAL_SUBMIT_FAIL_CONTENT,
            modalOk: EQUIPMENT_TYPE_EDIT_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_TYPE_EDIT_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
            }
          }));
        }
      }
    );
  };
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_TYPE_EDIT_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_TYPE_EDIT_TOGGLE_LOADING,
    data: show
  }
};
